import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=90f53330&scoped=true&"
import script from "./preloader.vue?vue&type=script&lang=js&"
export * from "./preloader.vue?vue&type=script&lang=js&"
import style0 from "./preloader.vue?vue&type=style&index=0&id=90f53330&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f53330",
  null
  
)

export default component.exports